import { useEffect } from 'react';

export function useScrollToTop(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [enabled]);
}